import React, { useState, useEffect } from 'react'
import HeadingArea from '../../general/HeadingArea'
import { AiOutlineSearch } from 'react-icons/ai';
import { FaUserEdit } from 'react-icons/fa';
import axios from 'axios';
import ResponseMsg2 from '../../general/ResponseMsg2';
// import { HiSearch } from 'react-icons/hi';


const AssignHostelRoom = ({ setLoading }) => {
  const [selectedSection, setSelectedSection] = useState('');
    const [response2, setResponse2] = useState({ message: '', status: 'success' });

  const [classes, setClasses] = useState([]);
  const [availableSections, setAvailableSections] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState('');
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedAY, setSelectedAY] = useState('');
  const [std, setStd] = useState([]);
  const [dormitory, setDormitory] = useState([]);
  const [selectedStd, setSelectedStd] = useState('');

   const [showStd, setShowStd] = useState(false);
       const [rooms, setRooms] = useState([]);

  const [searchFilter, setSearchFilter] = useState('');

const [selectedDormitory, setSelectedDormitory] = useState('');
const [selectedRoomId, setSelectedRoomId] = useState('');

const formatAssignDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear().toString();

  return `${day}-${month}-${year}`;
};


  const fetchClasses = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-classes');
      if (response.ok) {
        const data = await response.json();
        setClasses(data);
      } else {
        console.error('Failed to fetch class');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };


  const fetchAcademicYears = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-academic-years');
      if (response.ok) {
        const data = await response.json();
        setAcademicYears(data);
      } else {
        console.error('Failed to fetch academic years');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClasses();
    fetchAcademicYears();
    fetchHostel();
  }, []);


  useEffect(() => {
    if (selectedClassId) {
      const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
      if (selectedClass && selectedClass.sections) {
        const sectionArray = selectedClass.sections
          .split(',')
          .map((s) => s.trim())
          .filter((s) => s !== '');
        setAvailableSections(sectionArray);
      } else {
        setAvailableSections([]);
      }
      setSelectedSection('');
    } else {
      setAvailableSections([]);
      setSelectedSection('');
    }
  }, [selectedClassId, classes]);


  const handleSearch = async (e) => {
    e.preventDefault();

    if (!selectedAY || !selectedClassId) {
      alert('Please select both Academic Year and Class to search.');
      return;
    }

    setLoading(true);

    try {
      const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
      const className = selectedClass ? selectedClass.class_name : '';

      // Build query params
      const params = new URLSearchParams();
      params.append('ay', selectedAY);
      params.append('class_name', className);

      if (selectedSection) {
        params.append('section', selectedSection);
      }

      const url = `https://api.kcian.in/get-student?${params.toString()}`;

      const response = await fetch(url);

      if (response.ok) {
        const data = await response.json();
        console.log(data);
        setStd(data);

      } else {
        console.error('Failed to fetch students');
      }
    } catch (error) {
      console.error('Error fetching students:', error);
    } finally {
      setLoading(false);
    }
  };



  const fetchHostel = async () => {
    setLoading(true);
    try {
      const res = await axios.get('https://api.kcian.in/fetch-dormitory');
      setDormitory(res.data);

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };


const fetchRoomsByDormitory = async (dormitoryId) => {
  setLoading(true);
  try {
    const response = await axios.get(`https://api.kcian.in/fetch-hostel-room/${dormitoryId}`);
    setRooms(response.data);
  } catch (error) {
    console.error('Error fetching rooms by dormitory:', error);
    alert('Failed to load rooms.');
  } finally {
    setLoading(false);
  }
};

    
  const handleShowView = (std) => {
    setSelectedStd(std);
    setShowStd(true);
    setSelectedDormitory('');
    setSelectedRoomId('');
  }


    const filteredStd = std.filter(cls => {
  const term = searchFilter.toLowerCase();
  return (
    cls.reg_no.toLowerCase().includes(term) ||
    cls.name.toLowerCase().includes(term)
  );
});


const handleAssignRoom = async () => {
  if (!selectedDormitory || !selectedRoomId) {
      setResponse2({ message: 'Select Both Hostel & Room!', status: 'error' });
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    return;
  }

//  const selectedRoom = rooms.find((room) => String(room.id) === String(selectedRoomId));

//   if (selectedRoom) {
//     const { no_of_bed, bed_occupied } = selectedRoom;

//     if (Number(bed_occupied) >= Number(no_of_bed)) {
//       setResponse2({ message: 'Room is Full. Cannot assign more Students.', status: 'error' });
//       setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
//       return;
//     }
//   }

  setLoading(true);
  try {
    const res = await axios.put('https://api.kcian.in/assign-hostel-room', {
      'std_id': selectedStd.id,
      'room_id': selectedRoomId,
      'old_room_id': selectedStd.dor_room_id != null ? selectedStd.dor_room_id : null
    });

      setResponse2({ message: 'Room assigned successfully!', status: 'success' });
    setShowStd(false);
    window.location.reload();
  } catch (err) {
    console.error('Error assigning room:', err.response?.data || err.message);
  } finally {
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    setLoading(false);
  }
};


  return (
    <>
      <section className='py-4'>
        <div className='px-4'>
        <HeadingArea message1='Hostel' message2='Assign Rooms' />


          <form onSubmit={handleSearch} className='profile-card'>
            <span className="profile-heading">Select Criteria</span>

            <div className='d-md-flex d-sm-flex d-block mt-3'>
              <div className="mb-4 w-100 me-3">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select AY*</label>
                  <select
                    className="profile-input"
                    value={selectedAY}
                    onChange={(e) => setSelectedAY(e.target.value)}
                    required
                  >
                    <option value="">-- Select Academic Year --</option>
                    {academicYears.map((ay) => (
                      <option key={ay.year} value={ay.year}>
                        {ay.year} --- {ay.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-4 w-100 me-3">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select Class*</label>
                  <select
                    className="profile-input"
                    value={selectedClassId}
                    onChange={(e) => setSelectedClassId(e.target.value)}
                    required
                  >
                    <option value="">-- Select Class --</option>
                    {classes.map((cls) => (
                      <option key={cls.id} value={cls.id}>
                        {cls.class_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-4 w-100">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select Section*</label>
                  <select
                    className="profile-input"
                    value={selectedSection}
                    onChange={(e) => setSelectedSection(e.target.value)}
                    disabled={availableSections.length === 0}
                  >
                    <option value="">-- Select Section --</option>
                    {availableSections.map((section, idx) => (
                      <option key={idx} value={section}>
                        {section}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className='text-end'>
              <button type='submit' className='profile-btn2'>
                <AiOutlineSearch /> Search
              </button>
            </div>
          </form>

       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}
          <div className='profile-card mt-4'>
            <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
              <span className="profile-heading align-content-center">Assign Hostel Rooms</span>


              <div className='profile-input-area ms-auto col-lg-3 border-0'>
                <input
                  type='text'
                  name='search'
                  className='profile-input border-bottom rounded-0'
                  placeholder='Search...'
                  value={searchFilter}
                    onChange={(e) => setSearchFilter(e.target.value)}
                  // onChange={handleTextSearch}
                />
              </div>
            </div>

            <div className="table-responsive">
              <table className="table w-100 text-center" >
                <thead className="account-thead rounded-4">
                  {/* <tr> */}
                  <th className='rounded-start-4'>S No</th>
                  <th>Class(Section)</th>
                  <th>Registration  No</th>
                  <th>Student Name</th>
                  <th>Mobile</th>
                  <th>Action</th>
                
                  {/* </tr> */}
                </thead>
                <tbody>
                  {filteredStd.length > 0 ? (
                    filteredStd.map((item, index) => (
                      <tr className='account-tr' key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.class_name} ({item.section})</td>
                        <td>{item.reg_no}</td>
                        <td>{item.name}</td>
                        <td>{item.mobile}</td>
                      
                        <td>

                         <FaUserEdit className='emp-icon bg-primary' title='Assign Room' onClick={() => handleShowView(item)} />
                        </td>
                      </tr> 
                    ))
                  ) : (
                    <tr className='account-tr'>
                      <td colSpan="7">No records found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>



{showStd && (
  <section className='ins-dialog'>
    <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>
      <p className='ins-dialog-heading text-danger'>Assign Hostel Room to {selectedStd.name} - Class {selectedStd.class_name} ({selectedStd.section})</p>
       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

      <div className="row mt-4">

        <div className="col-md-6 mb-3">
                    <div className='profile-input-area'>
          <label className="profile-badge">Select Dormitory*</label>
<select
  className="profile-input"
  value={selectedDormitory}
  onChange={(e) => {
    const dormId = e.target.value;
    setSelectedDormitory(dormId);
    setSelectedRoomId('');
    if (dormId) {
      fetchRoomsByDormitory(dormId);
    } else {
      setRooms([]);
    }
  }}
>
            <option value="">-- Select Dormitory --</option>
            {dormitory.map((d) => (
              <option key={d.id} value={d.id}>
                {d.dormitory_name} ({d.type} Hostel)
              </option>
            ))}
          </select>
        </div>
        </div>


        <div className="col-md-6 mb-3">
          <div className='profile-input-area'>
          <label className="profile-badge">Select Room*</label>
<select
  className="profile-input"
  value={selectedRoomId}
  onChange={(e) => setSelectedRoomId(e.target.value)}
  disabled={!rooms.length}
>
  <option value="">-- Select Room --</option>
  {rooms.map((r) => (
<option key={r.id} value={r.id}>
  Room {r.room_no} - {r.room_type} ({r.no_of_bed} Beds) - ₹{r.bed_cost}/Bed
</option>
  ))}
</select>
        </div>
        </div>
      </div>

      <div className="text-end mt-3">
        <button className='profile-btn me-2' onClick={handleAssignRoom}>{selectedStd.dor_room_id != null ? 'Re Assign' : 'Assign'} Room</button>
        <button className='profile-btn2' onClick={() => setShowStd(false)}>Go Back</button>
      </div>


{selectedStd.dor_room_id != null && (
  <>
{selectedStd.dor_assign_on && (
  <>
    <p className='profile-heading'>
      Room Assigned on: {formatAssignDate(selectedStd.dor_assign_on)}
    </p>

    {(() => {
      const assignedRoom = rooms.find(r => String(r.id) == String(selectedStd.dor_room_id));
      if (!assignedRoom) return null;
      return (
        <p className='fw-semibold'>
          Assigned Room: Room No. {assignedRoom.room_no}<br />
          {/* {assignedRoom.room_type} ({assignedRoom.no_of_bed} Beds, {assignedRoom.bed_occupied} Occupied) - ₹{assignedRoom.bed_cost}/Bed */}
          {assignedRoom.room_type} ({assignedRoom.no_of_bed} Beds) - ₹{assignedRoom.bed_cost}/Bed
        </p>
      );
    })()}
  </>
)}


  </>
)}

    </div>
  </section>
)}


      </div>
      </section>
    </>
  )
}

export default AssignHostelRoom